import React, { useEffect, useRef } from 'react'; //eslint-disable-line no-unused-vars

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

export default usePrevious;
